import React, { useContext, useEffect, useRef, useState } from 'react'
import axiosAuthInstance from '../../utils/axios/axiosAuthInstance'
import { ProfileContext } from '../../context/profile';

const UserProfile = () => {
  const { saveProfile } = useContext(ProfileContext);

  const [profileData, setProfileData] = useState(null)
  const [picLoadng, setPicLoading] = useState(false)
  const fileInputRef = useRef(null)

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get('user/get-profile')
      if (response.status === 200) {
        const transformedData = response?.data?.result
        setProfileData(transformedData)
        saveProfile(transformedData)
      }
    } catch (error) {
      console.log('error :>> ', error);
    }
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0]
    if (file) {
      setPicLoading(true)
      const formData = new FormData()
      formData.append('photo', file)

      try {
        const response = await axiosAuthInstance.put('user/change-profile-pic', formData)
        if (response.status === 200) {
          fetchData()
        }
      } catch (error) {
        console.log('Error uploading photo:', error)
      } finally {
        setPicLoading(false)
      }
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  if (!profileData) {
    return <div>Loading...</div>
  }

  return (
    <>
      <div className='p-4'>
        <div className='bg-white text-black shadow-md rounded-lg p-6'>
          <h2 className='text-xl font-semibold mb-2'>Profile</h2>
          <div className='overflow-x-auto'>
            <table className='table-auto w-full border-collapse'>
              <tbody>
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Name</td>
                  <td className='border-b px-4 py-2'>{profileData.name || profileData.full_name}</td>
                </tr>
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Email</td>
                  <td className='border-b px-4 py-2'>{profileData.email}</td>
                </tr>
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Role</td>
                  <td className='border-b px-4 py-2'>{profileData.role}</td>
                </tr>
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Profile Photo</td>
                  <td className='border-b px-4 py-2'>
                    {profileData?.photo ? (
                      <>
                        <img
                          src={profileData.photo}
                          alt='Profile image'
                          className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                        />
                        <button
                          disabled={picLoadng}
                          onClick={() => fileInputRef.current.click()}
                          className='mt-2 bg-primary text-white px-4 py-2 rounded w-36'>
                          {picLoadng ?
                            <div className='w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent'></div>
                            : "Change Photo"
                          }
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          disabled={picLoadng}
                          onClick={() => fileInputRef.current.click()}
                          className='mt-2 bg-primary text-white px-4 py-2 rounded w-36'>
                          {picLoadng ?
                            <div className='w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent'></div>
                            : "Add Photo"
                          }
                        </button>
                      </>
                    )}
                    <input
                      ref={fileInputRef}
                      type='file'
                      accept='image/*'
                      className='hidden'
                      onChange={handleFileChange}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserProfile